import React, {useState} from "react";
import {Field} from "react-final-form";
import {required} from "src/core/common/validations";
import styled from "styled-components";
import {KeyboardBackspace} from "styled-icons/material/KeyboardBackspace";
import NewCardForm from "src/core/payments/merrco/NewCardForm";
import CardListField from "src/core/payments/CardComponents/CardListField";
import Error from "src/core/common/components/elements/Error";
import {PrimaryLoadingButton} from "src/core/common/components/elements/button/PrimaryButton";
import useAuthentication from "src/core/authentication/hooks/useAuthentication";
import MerrcoPaymentSourcesDataSource from "src/core/payments/merrco/merccoPaymentSourcesDataSource";

function UserProfileMerrcoCardSelectionField({
  paymentOption,
  form,
  order,
  readOnly,
  disabled,
  profile = false,
  handleSubmit,
}) {
  const [, authApi] = useAuthentication();
  const loggedIn = authApi.isLoggedIn();

  const [showForm, setShowForm] = useState(!loggedIn);
  const [loading, setLoading] = useState(false);

  if (!showForm || readOnly) {
    return (
      <Field
        validate={required}
        initialValue={
          order ? order.getPaymentSpecification().getPaymentInfo() : undefined
        }
        name="payment.source"
        render={({input, meta}) => (
          <>
            <CardListField
              input={input}
              loading={loading}
              disabled={disabled}
              order={order}
              form={form}
              readOnly={readOnly}
              paymentOption={paymentOption}
              profile={profile}
              dataSource={paymentSourcesDataSource}
              hideAddButton={false}
              showForm={() => !loading && !disabled && setShowForm(true)}
            />
            {meta.touched && <Error>{meta.error}</Error>}
          </>
        )}
      />
    );
  } else {
    return (
      <div>
        {loggedIn && (
          <BackButton onClick={() => setShowForm(false)}>
            <BackIcon />
            Select another card
          </BackButton>
        )}
        <NewCardForm
          setLoading={setLoading}
          paymentOption={paymentOption}
          form={form}
          disabled={disabled}
        />
        {profile && <PrimaryLoadingButton label="Add card" onClick={handleSubmit} />}
      </div>
    );
  }
}

const paymentSourcesDataSource = new MerrcoPaymentSourcesDataSource();

const BackButton = styled.a`
  height: 32px;
  cursor: pointer;
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  color: black;

  font-weight: ${({theme}) => theme.v2.typography.primary.weight.heavy};
`;

const BackIcon = styled(KeyboardBackspace)`
  margin-right: 10px;
  width: 25px;
`;

export default UserProfileMerrcoCardSelectionField;
